module.exports = __webpack_public_path__ + "static/media/HostGuestLandingScreen.2c1b8dd2.png";